import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {AnalyticsCandidateSourcePerformanceActions} from 'src/action-creators/analytics/analytics-candidate-source-performance';
import type {
  SavedDashboardList,
  CandidateSourcePerformanceFilters,
  SelectedCandidateSourceColumnsData,
} from 'src/types/analytics-genesis';

import {
  SET_CURRENT_DASHBOARD_ID,
  SET_SELECTED_DATE_RANGE,
  CLEAR_SELECTED_FILTERS,
  RECEIVE_SAVED_DASHBOARDS,
  SET_SELECTED_CANDIDATE_SOURCE_FILTERS,
  RECEIVE_AGENCY_PERFORMANCE_TABLE_COLUMNS,
  RECEIVE_ALL_SOURCE_TABLE_COLUMNS,
  RECEIVE_SUB_SOURCE_TABLE_COLUMNS,
} from 'src/action-creators/analytics/analytics-candidate-source-performance';


export type AnalyticsCandidateSourcePerformanceState = {
  savedDashboards: SavedDashboardList;
  selectedDateRange: DateRangeWithTimezone;
  currentDashboardID: string | null | undefined;
  selectedCandidateSourceFilters: CandidateSourcePerformanceFilters;
  allSourcesTableColumnFilter: SelectedCandidateSourceColumnsData | null;
  agencyPerformanceTableColumnFilter: SelectedCandidateSourceColumnsData | null;
  subSourcesTableColumnFilter: SelectedCandidateSourceColumnsData | null;
};

const initialState: AnalyticsCandidateSourcePerformanceState = {
  savedDashboards: [],
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  currentDashboardID: null,
  selectedCandidateSourceFilters: {
    job_id_title: [],
    job_department: [],
    job_location: [],
  },
  allSourcesTableColumnFilter: null,
  agencyPerformanceTableColumnFilter: null,
  subSourcesTableColumnFilter: null,
};

export default (
  state: AnalyticsCandidateSourcePerformanceState = initialState,
  action: AnalyticsCandidateSourcePerformanceActions,
): AnalyticsCandidateSourcePerformanceState => {
  switch (action.type) {
    case SET_SELECTED_DATE_RANGE: {
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }
    case RECEIVE_SAVED_DASHBOARDS: {
      return {
        ...state,
        savedDashboards: action.payload,
      };
    }
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case SET_SELECTED_CANDIDATE_SOURCE_FILTERS: {
      const {selectedCandidateSourceFilters} = state;
      return {
        ...state,
        selectedCandidateSourceFilters: {
          ...selectedCandidateSourceFilters,
          ...action.payload,
        },
      };
    }
    case CLEAR_SELECTED_FILTERS: {
      return {
        ...state,
        selectedCandidateSourceFilters: {
          job_id_title: [],
          job_department: [],
          job_location: [],
        },
      };
    }
    case RECEIVE_ALL_SOURCE_TABLE_COLUMNS: {
      return {...state, allSourcesTableColumnFilter: action.payload};
    }
    case RECEIVE_AGENCY_PERFORMANCE_TABLE_COLUMNS: {
      return {...state, agencyPerformanceTableColumnFilter: action.payload};
    }
    case RECEIVE_SUB_SOURCE_TABLE_COLUMNS: {
      return {...state, subSourcesTableColumnFilter: action.payload};
    }
  }

  return state;
};
